"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MapPin, Instagram } from "lucide-react";
const locations = [{
  id: "loc-1",
  name: "Detroit Studio Hub",
  address: "1200 Woodward Ave, Detroit, MI 48226"
}, {
  id: "loc-2",
  name: "Grand Rapids Creative",
  address: "250 Monroe Ave NW, Grand Rapids, MI 49503"
}, {
  id: "loc-3",
  name: "Ann Arbor Sound Lab",
  address: "300 S Main St, Ann Arbor, MI 48104"
}];
const socials = [{
  id: "soc-1",
  icon: Instagram,
  label: "Instagram",
  href: "https://www.instagram.com/heavenshorizonrecords/"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/ArtistsPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Artists</Link>
        </li>
        <li data-index={2}>
          <Link to="/ReleasesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">Releases</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265041" id="footer" className="bg-background border-t border-border/50 pt-16 pb-8 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto drop-shadow-[0_0_10px_rgba(0,255,255,0.5)]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6 font-default font-light">Elevating independent artists beyond the horizon. Michigan's premier label for EDM, Pop, and Country fusion. We craft the future of sound with cinematic vision and festival energy. With Innovative and Creative THinking Our label is always uptodate releasing something new..</p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-wider uppercase">
              Navigation
            </h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-wider uppercase">
              Follow The Sound
            </h3>
            <div className="flex items-center gap-4 mb-8">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.id} to={social.href} data-index={i} className="w-12 h-12 rounded-lg bg-card/50 backdrop-blur-md border border-primary/30 flex items-center justify-center text-muted-foreground hover:border-primary hover:text-primary hover:shadow-[0_0_15px_rgba(0,255,255,0.4)] transition-all duration-500" aria-label={social.label}>
                    <Icon className="w-5 h-5" />
                  </Link>;
            })}
            </div>
            <ul className="space-y-5">
              
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <span className="text-sm text-muted-foreground leading-snug font-default">Grand Rapids, Michigan Headquarters</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 tracking-wider uppercase">
              Join The Label
            </h3>
            <div className="bg-card/30 backdrop-blur-xl p-5 rounded-2xl border border-white/10 shadow-xl">
              <h4 className="font-default font-semibold text-primary mb-2">Artist Submissions</h4>
              <p className="text-sm text-muted-foreground mb-4 font-default">Ready to take your music to the next horizon? Send us your demo.</p>
              <Button asChild className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-opacity rounded-lg font-default font-bold">
                <Link to="/SubmissionsPage">Submit Demo</Link>
              </Button>
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-border/30" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-[12px] text-muted-foreground font-default">
          <p>© {currentYear} Heavens Horizon Records LLC. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}